import { MINOR_PER_UNIT } from './asset.js';
import { InvalidAmountError } from './errors.js';
import { money } from './money.js';
import { divide } from './rounding.js';
/**
 * Prices are quoted per 1,000,000 GAJU, not per GAJU.
 *
 * GAJU supply is above a trillion, so one GAJU is worth a minute fraction of a
 * cent and a price per GAJU would not be an integer number of USDC minor units.
 * Quoting per million makes the price an exact integer, and it happens to be
 * the unit the product shows people anyway, so the number in the database is
 * the number on the screen.
 */
export const PRICE_UNIT_GAJU = 1000000n;
/** Aettos in one price unit: 1,000,000 GAJU x 10^18. */
export const PRICE_UNIT_AETTOS = PRICE_UNIT_GAJU * MINOR_PER_UNIT.GAJU;
export function price(usdcMinorPerMillionGaju) {
    if (usdcMinorPerMillionGaju <= 0n) {
        throw new InvalidAmountError(`Price must be positive, got ${usdcMinorPerMillionGaju}`);
    }
    return usdcMinorPerMillionGaju;
}
/**
 * What a quantity of GAJU costs at a price.
 *
 * `rounding` decides who absorbs the sub-unit remainder, so the caller has to
 * say. A buyer's lock rounds up so the lock always covers the trade; a fill's
 * settlement rounds down so the two sides move exactly the same number.
 */
export function costOf(quantityAettos, at, rounding) {
    if (quantityAettos < 0n) {
        throw new InvalidAmountError(`Quantity must not be negative, got ${quantityAettos}`);
    }
    return money('USDC', divide(quantityAettos * at, PRICE_UNIT_AETTOS, rounding));
}
/** How much GAJU a given number of USDC minor units buys at a price. */
export function quantityFor(usdcMinor, at, rounding) {
    if (usdcMinor < 0n) {
        throw new InvalidAmountError(`Amount must not be negative, got ${usdcMinor}`);
    }
    return divide(usdcMinor * PRICE_UNIT_AETTOS, at, rounding);
}
//# sourceMappingURL=price.js.map